import React, { FunctionComponent, useEffect, useState } from 'react';
import { Breadcrumbs } from 'baseui/breadcrumbs';
import { StyledLink } from 'baseui/link';
import { useTranslation } from 'react-i18next';
import { useLocation, matchPath } from 'react-router-dom';
import { routing, RoutingItem } from '../../config/routing';

const matchedSkeletonRoute = (currentPath: string, routeObject: RoutingItem, parrentPath: string): boolean => {
    const matchProfile = (matchPath(currentPath, {
        path: parrentPath + routeObject.path,
    }))

    if (matchProfile && matchProfile.params && matchProfile.isExact) return true;
    return false;
}

const returnSkeletonRoute = (currentPath: string, all_routes: any, parrentPath: string): Array<RoutingItem>|undefined => {
    let nestedSkeletonRoutes: Array<RoutingItem> = [];
    if (Array.isArray(all_routes)) {
        all_routes.forEach((element: any) => {
            const found = returnSkeletonRoute(currentPath, element, parrentPath)
            //@ts-ignore
            if (found && found.exact) nestedSkeletonRoutes.push(found)
        })
        return nestedSkeletonRoutes;
    }
    else if (all_routes.children) {
        if (!matchedSkeletonRoute(currentPath, all_routes, parrentPath)) {
            const found = returnSkeletonRoute(currentPath, all_routes.children, parrentPath + all_routes.path)
            if (found && found.length) {
                found.forEach((element: any) => {
                    nestedSkeletonRoutes.push(element)
                })
            }

            if (nestedSkeletonRoutes.length > 0) {
                nestedSkeletonRoutes.unshift(all_routes)
                return nestedSkeletonRoutes;
            }
        }
        else return all_routes;
    }
    else if (matchedSkeletonRoute(currentPath, all_routes, parrentPath)) return all_routes;

    return undefined;
}

const getMainPath = (all_routes: Array<RoutingItem>): RoutingItem | null => {
    for (const single_route of all_routes) {
        if (single_route.path === '/') return single_route
    }
    return null;
}

const findRoute = (path: string, all_routes: Array<RoutingItem>): Array<RoutingItem> => {
    const mainPath = getMainPath(all_routes);

    let allMatchedRoutes:Array<RoutingItem> = [];
    if (mainPath) allMatchedRoutes.push(mainPath);
    //@ts-ignore
    for (const single_route of all_routes) allMatchedRoutes.push(returnSkeletonRoute(path, single_route, ''));

    allMatchedRoutes = allMatchedRoutes.filter( element => element !== undefined );
    return allMatchedRoutes.flat();
};

export const RoutingBreadcrumbs: FunctionComponent = () => {
    const [sectionsInfo, setSectionsInfo] = useState<
        Array<Partial<RoutingItem>>
    >([]);
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const getBreadcrumbs = () => {
        const arr: Array<any> = [];
        let prevLink: string = '#';

        for (let i = 0; i < sectionsInfo.length; ++i) {
            arr.push(
                <StyledLink
                    key={sectionsInfo[i]?.title}
                    href={
                        i === sectionsInfo.length - 1
                            ? undefined
                            : `${prevLink}${sectionsInfo[i].path || ''}`
                    }
                >
                    {t(sectionsInfo[i]?.title as string)}
                </StyledLink>,
            );
            prevLink += sectionsInfo[i].path || '';
        }

        return arr;
    };

    useEffect(() => {
        setSectionsInfo([
            {
                title: t('appName'),
            },
            ...findRoute(pathname, routing),
        ]);
    }, [pathname]);

    return <Breadcrumbs>{getBreadcrumbs()}</Breadcrumbs>;
};
